import { EventEmitter, Injectable } from '@angular/core';

interface InputDataSource { markAsPristine?: Function, markAsTouched?: Function };

@Injectable()
export class FormValidationService {

	public stateChanged = new EventEmitter<FormState>(true);
	private validStates = new Map<InputDataSource, boolean>();
	private pristineStates = new Map<InputDataSource, boolean>();
	private formSaved = false;

	constructor() {
		this.stateChanged.next(FormState.Pristine);
	}

	public fieldStateChanged(stateObject: InputDataSource, isValid: boolean, isPristine: boolean): void {
		this.validStates.set(stateObject, isValid);
		this.pristineStates.set(stateObject, isPristine);
		this.refreshState();
	}
	public removeField(stateObject: InputDataSource) {
		this.validStates.delete(stateObject);
		this.pristineStates.delete(stateObject);
		this.refreshState();
	}

	public saved(): void {
		this.formSaved = true;
		this.setPristine();
	}
	public reset(): void {
		this.formSaved = false;
		this.setPristine();
	}
	// Check whether form is valid, regardless of pristine state
	public isValid(): boolean {
		for (let isValid of this.validStates.values()) {
			if (!isValid) return false;
		}
		return true;
	}

	private setPristine(): void {
		for (const validator of this.validStates.keys()) validator.markAsPristine?.();
		this.refreshState();
	}

	public validatePristineFields() {
		for (const validator of this.validStates.keys()) validator.markAsTouched?.();
		this.refreshState();
	}

	private refreshState() {
		let state = FormState.Pristine;

		for (let isPristine of this.pristineStates.values()) {
			if (!isPristine) {
				state = FormState.Valid;
				break;
			}
		}

		if (state !== FormState.Pristine) {
			for (let isValid of this.validStates.values()) {
				if (!isValid) {
					state = FormState.Invalid;
					break;
				}
			}
		}

		if (state === FormState.Pristine && this.formSaved) state = FormState.Saved;
		this.stateChanged.next(state);
	}
}

export enum FormState {
	Pristine, Saved, Valid, Invalid
}
